export default __webpack_public_path__ + "static/media/fast_food.4cc24d27.svg";